export const mappedCurrentNames = {
  current_voltage_wave: 'Current Voltage Waveform',
  current_voltage_wave_manual: 'Current Voltage Waveform Manual',
  current_voltage_wave_boot: 'Current Voltage Waveform Boot'
};

export const mappedCurrentKeys = Object.keys(mappedCurrentNames);
export const mappedCurrentSelect = [
  { event: Object.keys(mappedCurrentNames), label: 'All' },
  ...Object.keys(mappedCurrentNames).map(key => ({
    event: key,
    label: mappedCurrentNames[key]
  }))
];
